import Sentry, { featureTags } from '@/services/sentry'
import Constant from '@/constant'

const MAX_TITLE_LENGTH = 100
const IMPORT_FILE_EXTENSION = /\.(pptx|ppt|pdf|key)$/i

export const titleFromImportedFileName = (fileName) => {
  if (typeof fileName !== 'string') return ''
  return fileName.trim().replace(IMPORT_FILE_EXTENSION, '').trim().substring(0, MAX_TITLE_LENGTH)
}

const reportError = (error) => Sentry.captureException(error, {
  tags: featureTags({
    featureFlag: 'AHA-48782-import-file-name-title',
    featureName: 'import-file-name-title',
    taskId: 'AHA-48782',
  }),
})

const hasDefaultName = (presentation) => {
  const isDefaultName = !presentation.name || presentation.name === Constant.presentation.defaultPresentationName
  return isDefaultName && !presentation.hasAutoSuggestedTitle
}

export const applyImportedFileNameAsTitle = async ({
  presentation, presentationId, fileName, savePresentationName, patchPresentation,
}) => {
  try {
    const title = titleFromImportedFileName(fileName)
    if (!title || presentation?.id !== presentationId || !hasDefaultName(presentation)) return

    const response = await savePresentationName(title)
    if (response?.body?.error) {
      reportError(new Error(response.body.error))
      return
    }
    patchPresentation({ name: title, hasAutoSuggestedTitle: true })
  } catch (error) {
    reportError(error)
  }
}
